var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"simbolo",class:{ 'simbolo-forma': _vm.datos.forma },style:(_vm.estilo)},[_c('v-icon',{attrs:{"size":_vm.tamanoIcono,"color":_vm.datos.forma ? _vm.color : 'white'}},[_vm._v(_vm._s(_vm.datos.icono))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }